import { createSlice } from "@reduxjs/toolkit";

const initialState: UIInsumosLocal = {
    local: {},
    produtos: [],
}
export interface UIInsumosLocal {
    local: any
    produtos: any[]
}

export const insumosLocalSlice = createSlice({
    name: "uiInsumosLocal",
    initialState,
    reducers: {
        atualizar: (state, action) => {
            state.produtos = action.payload.produtos
            state.local = action.payload.local
        },
        atualizarLocal: (state, action) => {
            state.local = action.payload.local
        },
        atualizarProdutos: (state, action) => {
            state.produtos = action.payload.produtos
        },
    }
})

export const { atualizar, atualizarLocal, atualizarProdutos } = insumosLocalSlice.actions

export default insumosLocalSlice.reducer
